import { render, staticRenderFns } from "./AdminFacilityForm.vue?vue&type=template&id=6681bc2c"
import script from "./AdminFacilityForm.vue?vue&type=script&lang=ts"
export * from "./AdminFacilityForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports